import React from "react";
import "./GetMusicOnYouTubeMusic.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnYouTubeMusic = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select YouTube Music distribution",
    "Music delivered to YouTube Music",
    "Reach global listeners instantly",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>YouTube Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to YouTube Music worldwide with FT Tunes. Reach millions of listeners and monetize your tracks globally."
        />

        <meta
          name="keywords"
          content="YouTube Music distribution, distribute to YouTube Music, music distribution service"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="ytmusic-page">

        {/* HERO */}
        <section className="ytmusic-hero">
          <Container>

            <img
              src="/Images/youtube-music-logo.png"
              alt="YouTube Music"
              className="ytmusic-logo"
            />

            <h1>Distribute Your Music on YouTube Music</h1>

            <p>
              Reach millions of listeners worldwide by delivering your music
              directly to YouTube Music and the global YouTube ecosystem.
            </p>

            <Button
              className="gradient-btn-ytmusic"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-ytmusic"></div>
        </section>


        {/* SHOWCASE */}
        <section className="ytmusic-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Massive Reach Across YouTube Ecosystem</h2>

                <p>
                  Your music becomes discoverable across YouTube Music,
                  YouTube search, playlists, smart TVs, and mobile apps —
                  giving you unmatched global exposure.
                </p>

                <Button
                  className="outline-btn-ytmusic"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-youtube-music.png"
                  alt="YouTube Music Distribution"
                  className="ytmusic-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="ytmusic-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-ytmusic">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="ytmusic-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on YouTube Music
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-ytmusic">
                  <h5>Global Audience</h5>
                  <p>Reach billions through YouTube platform.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-ytmusic">
                  <h5>Playlist Placement</h5>
                  <p>Get featured on algorithmic playlists.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-ytmusic">
                  <h5>Content ID Monetization</h5>
                  <p>Earn revenue from user-generated videos.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-ytmusic">
                  <h5>Analytics Dashboard</h5>
                  <p>Track streams, revenue & audience data.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="ytmusic-cta">
          <Container>

            <h2>Start Your YouTube Music Distribution Today</h2>

            <Button
              className="gradient-btn-ytmusic big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnYouTubeMusic;